import React from "react";

export const LetterA = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width           = {props.width || "26"}
    height          = {props.height || "26"}
    strokeWidth     = "1.5"
    fill="currentColor"
    {...props}
  >
  <text x="4.5" y="20" fontSize="2.5rem" fontWeight='normal'>A</text>
  </svg>
);
